module.exports = __webpack_public_path__ + "img/medal.e791373e.png";